import {
  CARD_PAYMENT_API,
  FETCH_EXCHANGE_RATE_API,
  FETCH_PAYMENT_TRANSACTION_API,
  FETCH_TRANSACTIONS_API,
  FETCH_WALLET_API,
  INITIATE_BANK_TRANSFER_API,
  INITIATE_CASHIA_WITHDRAWAL_API,
  INITIATE_MERCHANT_PAYMENT_API,
  INITIATE_STK_PUSH_API,
  PaymentCurrencyEnum,
  PaymentExchangeRateTypeEnum,
  TRANSFERS_API,
  WITHDRAW_API,
} from "_constants";
import { paymentRequest } from "_helpers";

const fetchWallet = () => {
  return paymentRequest.get(FETCH_WALLET_API);
};

const fetchTransactions = () => {
  return paymentRequest.get(FETCH_TRANSACTIONS_API);
};

/**
@param {Object} stkPushData
@param {String} stkPushData.AccountReference
@param {String} stkPushData.Amount
@param {String} stkPushData.PhoneNumber

@returns {Promise}
*/
const initiateStkPush = (stkPushData) => {
  return paymentRequest.post(INITIATE_STK_PUSH_API, stkPushData);
};

/**
@param {Object} withdrawData
@param {String} withdrawData.accountId
@param {String} withdrawData.amount

@returns {Promise}
*/
const withdraw = (withdrawData) => {
  return paymentRequest.post(WITHDRAW_API, withdrawData);
};

/**
@param {Object} exchangeRateDetails
@param {String} exchangeRateDetails.fromCurrency
@param {String} exchangeRateDetails.toCurrency
@param {String} exchangeRateDetails.amount

@returns {Promise}
*/
const fetchExchangeRate = (exchangeRateDetails) => {
  if (!exchangeRateDetails) {
    exchangeRateDetails = {
      amount: 1,
      fromCurrency: PaymentCurrencyEnum.USD,
      toCurrency: PaymentCurrencyEnum.KES,
      type: PaymentExchangeRateTypeEnum.DEPOSIT,
    };
  }
  return paymentRequest.post(FETCH_EXCHANGE_RATE_API, exchangeRateDetails);
};

/**
@param {Object} transfersDetails
@param {String} transfersDetails.fromAccountId
@param {String} transfersDetails.toAccountId
@param {String} transfersDetails.transferAmount

@returns {Promise}
*/

const transfers = (transfersDetails) => {
  return paymentRequest.post(TRANSFERS_API, transfersDetails);
};

/**
@param {Object} initiateCardPaymentDetails
@param {String} initiateCardPaymentDetails.accountId
@param {String} initiateCardPaymentDetails.amount
@param {String} initiateCardPaymentDetails.requestCurrency
@param {String} initiateCardPaymentDetails.phoneNumber

@returns {Promise}
*/

const initiateCardPayment = (initiateCardPaymentDetails) => {
  return paymentRequest.post(CARD_PAYMENT_API, initiateCardPaymentDetails);
};

/**
@param {Object} initiateBankTransferDetails
@param {String} initiateBankTransferDetails.accountId
@param {String} initiateBankTransferDetails.amount
@param {String} initiateBankTransferDetails.transferAmount


@returns {Promise}
*/

const initiateBankTransfer = (initiateBankTransferDetails) => {
  return paymentRequest.post(
    INITIATE_BANK_TRANSFER_API,
    initiateBankTransferDetails,
  );
};

/**
@param {Object} initiateMerchantPaymentDetails
@param {String} initiateMerchantPaymentDetails.accountId
@param {String} initiateMerchantPaymentDetails.amount
@param {String} initiateMerchantPaymentDetails.phoneNumber


@returns {Promise}
*/

const initiateMerchantPayment = (initiateMerchantPaymentDetails) => {
  return paymentRequest.post(
    INITIATE_MERCHANT_PAYMENT_API,
    initiateMerchantPaymentDetails,
  );
};

const fetchPaymentTransaction = (uniqueRequestId) => {
  return paymentRequest.get(`${FETCH_PAYMENT_TRANSACTION_API}/${uniqueRequestId}`);
};

/**
@param {Object} initiateCashiaWithdrawalDetails
@param {String} initiateCashiaWithdrawalDetails.accountId
@param {Number} initiateCashiaWithdrawalDetails.amount
@param {String} initiateCashiaWithdrawalDetails.contactUid
@param {String} initiateCashiaWithdrawalDetails.requestCurrency

@returns {Promise}
*/

const initiateCashiaWithdrawal = (initiateCashiaWithdrawalDetails) => {
  return paymentRequest.post(
    INITIATE_CASHIA_WITHDRAWAL_API,
    initiateCashiaWithdrawalDetails,
  );
};

export const paymentService = {
  fetchWallet,
  fetchTransactions,
  initiateStkPush,
  withdraw,
  fetchExchangeRate,
  transfers,
  initiateCardPayment,
  initiateBankTransfer,
  initiateMerchantPayment,
  fetchPaymentTransaction,
  initiateCashiaWithdrawal,
};
